module.exports = __webpack_public_path__ + "img/DE00827.2aa24622.png";